module.exports = __webpack_public_path__ + "images/feature/feature_1220_3-34bcd72b8887b0a812ea5602c1af027d.png";